<svg width="21" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M17 1.67H3.67C2.75 1.67 2 2.4 2 3.33v10c0 .92.75 1.67 1.67 1.67h2.5v3.14L11.4 15H17c.92 0 1.67-.75 1.67-1.67v-10c0-.92-.75-1.66-1.67-1.66Zm0 11.66h-6.06l-3.1 1.86v-1.86H3.66v-10H17v10Z"
    fill="currentColor"
  />
  <path
    d="M6.17 5.83h8.33V7.5H6.17V5.83Zm0 3.34H12v1.66H6.17V9.17Z"
    fill="currentColor"
  />
</svg>
